import { useState } from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FromLayout from "../../component/FromLayout";
import { useForgotPasswordMutation } from "../../store/api/authSlice";
import {
  capitalizeFirstLetter,
  handleApiError,
} from "../../utils/dateAndTimeConversion";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
  });

  const [errors, setErrors] = useState({});
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const validateForm = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value)
        newErrors[key] = `${t("errors." + key)} ${t("errors.required")}`;
    });
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = t("invalid_email_format");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    setErrors((prev) => ({
      ...prev,
      [name]: value ? "" : `${t("errors." + name)} ${t("errors.required")}`,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    toast.dismiss();

    try {
      const response = await forgotPassword(formData).unwrap();
      if (response.statusCode === 200) {
        toast.success(response.message);
        navigate("/otp-verification", { state: { email: formData.email } });
      }
    } catch (error) {
      handleApiError(error, t);
    }
  };

  return (
    <FromLayout title={` ${t("forgot")} ${t("password")}`} width="w-40">
      <div className="text-center mb-5">
        <p
          className="text-light"
          style={{
            opacity: 0.8,
            paddingLeft: "25px",
            paddingRight: "25px",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          {t("reset_password_note")}
        </p>
      </div>

      {/* Centered form container */}
      <div className="d-flex justify-content-center">
        <div style={{ width: "100%", maxWidth: "500px" }}>
          <form onSubmit={handleSubmit}>
            {/* Email Field */}
            <div className="row g-3 text-start mb-4">
              <div className="col-12">
                <label className="form-label text-white">
                  {t("email")} {t("address")}
                </label>
                <input
                  type="email"
                  className="form-control mb-1"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={`${t("enter")} ${t("your")} ${t("email")}`}
                />
                {errors.email && (
                  <span style={{ color: "red" }}>{errors.email}</span>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="row g-3 text-start mb-4">
              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn-amber rounded-3 px-4 w-100"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div className="spinner-border" role="status">
                      <span className="sr-only p-0"></span>
                    </div>
                  ) : (
                    t("btns.submit")
                  )}
                </button>
              </div>
            </div>

            {/*login  link for school */}
            <div className="text-center  mt-4">
              <Link
                to="/#"
                className="hover-link "
                style={{
                  color: "#f0b241",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.textDecoration = "underline")
                }
                onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
              >
                {t("back")} {t("to")} {t("login")}{" "}
                <FaArrowRightLong className="ms-2" />
              </Link>
            </div>
          </form>
        </div>
      </div>

      {/* Add custom styles for transparent checkbox */}
      <style jsx>{`
        .form-check-input {
          background-color: transparent !important;
          border: 1px solid #fff !important;
        }

        .form-check-input:checked {
          background-color: #f0b241 !important;
          border-color: #f0b241 !important;
        }

        .form-check-input:focus {
          box-shadow: 0 0 0 0.2rem rgba(240, 178, 65, 0.25) !important;
        }
      `}</style>
    </FromLayout>
  );
};

export default ForgotPassword;
